const secure = '(/secure/|/)';
export const legacyGinManageRoute = {
	name: 'legacy-gin-manage',
	path: `${secure}ManageFilters.jspa`,
};
